'use client';
import { useState } from 'react';
import { clsx } from 'clsx';
import { useSearchParams } from 'next/navigation';
import { CloseIcon, Icon } from '../Icon';
import styles from './SearchBar.module.scss';

export const SearchBar = ({ marginBottom, ctaText }: { marginBottom?: boolean; ctaText?: string }) => {
  const params = useSearchParams();
  const [value, setValue] = useState<string>(params.get('q') ?? '');

  return (
    <form className={clsx(styles.form, marginBottom && styles.marginBottom)} target="_top" action="/suche">
      <div className={styles.inputWrapper}>
        <button className={styles.icon} type="submit" aria-label="Icon: Suchen">
          <Icon name="search" size={20} />
        </button>
        <input
          className={styles.input}
          type="search"
          name="q"
          placeholder="Suche"
          autoComplete="off"
          value={value}
          onChange={(e) => setValue(e.target.value)}
          aria-label="Suche"
        />
        <CloseIcon onClose={() => setValue('')} label="Suche zurücksetzen" className={styles.closeIcon} />
      </div>

      {ctaText && (
        <button className={styles.ctaButton} type="submit" aria-label="Button: Suchen">
          {ctaText}
        </button>
      )}
    </form>
  );
};
